import service from "./tunnel/service";

export default {
    service
}